/**
 * apps/web :: pass :: PassApp
 *
 * Nested router for the `/pass/*` surface. Every screen registered a
 * `PassRouteDescriptor` collected in `PASS_ROUTES`; the descriptor with an
 * empty `path` (the pack home) renders as the index route. The registry
 * indirection is what let the parallel Wave-1 tasks each add a screen
 * WITHOUT editing this file.
 */
import { Routes, Route } from "react-router-dom";

import { PASS_ROUTES } from "./passRoutes";

export default function PassApp(): JSX.Element {
  return (
    <Routes>
      {PASS_ROUTES.map((r) =>
        r.path === "" ? (
          <Route key="index" index element={r.element} />
        ) : (
          <Route key={r.path} path={r.path} element={r.element} />
        ),
      )}
    </Routes>
  );
}
